// extracted by mini-css-extract-plugin
export default {"productGallery":"iO-z","inQuickShop":"jO-z"};